export const isValidPhoneNumberRegex = /^(\+?(1|20)\s*)?\(?\d{3}\)?[\s.,-]*\d{3}[\s.,-]*\d{4}$/;
export const isValidPhoneNumber = (str) => isValidPhoneNumberRegex.test(str);
export const prepareUserDataForBackend = (values) => {
  if (!values.firstName && !values.lastName) {
    return values;
  }
  return {
    ...values,
    firstName: values.firstName.trim().toLowerCase(),
    lastName: values.lastName.trim().toLowerCase(),
  };
};
